import './Home.css';
import React, { useState } from 'react';
import Weather from '../components/weather';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../i18n';
import { RootState } from '../store';
import { Dispatch } from 'redux';
import { ERepositoryPage, IPhoto } from './types';
import axios from '../api/axios';
import { useParams } from 'react-router-dom';
import { setBuildingId } from '../store/actions/buildingIdAction';

interface IHomePageProps {}

const HomePage: React.FC<IHomePageProps> = () => {
    const { language } = useSelector((state: RootState) => state.lang);
    const [photo, SetPhoto] = useState<string>('');

    const params = useParams();
    const buildingId = params.buildingId;

    const dispatch = useDispatch();
    dispatch(setBuildingId(String(buildingId)));

    const GET_IMAGES_URL = '/api/hblogin/repository/GetImagesByBuildingId';

    React.useEffect(() => {
        axios
            .get<IPhoto[]>(`${GET_IMAGES_URL}`, { params: { id: buildingId } })
            .then((reponse) => reponse.data)
            .then((photos) => {
                let hero = photos.filter((photo) => photo.repositoryPage == ERepositoryPage.hero)[0];
                SetPhoto(hero.urlEnglishHorizontal);
            });
    }, []);

    return (
        <div className="Home">
            <div className="Home-Left Drop-Shadow">
                <img src={photo} alt="HeroImage" width="100%" height="100%" />
            </div>
            <div className="Home-Right Drop-Shadow">
                <div className="Home-Right-Title">{translate('Weather', language)}</div>
                <Weather />
            </div>
        </div>
    );
};

export default HomePage;
